var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, FormController, FormLabel, Input, LoadingButton, Modal, ModalBody, ModalFooter, ModalHeader, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { editPOJobName } from '../../../api/oms/order-history';
import { setEditJobNameError, } from '../../../utils/purchase-history/analytics';
import { getSvocId } from '../../../utils/user';
export var PoJobNameModal = function (_a) {
    var _b, _c, _d, _e, _f;
    var page = _a.page, order = _a.order, openModal = _a.openModal, setOpenModal = _a.setOpenModal, _g = _a.visiblePoJobName, visiblePoJobName = _g === void 0 ? '' : _g, setVisiblePoJobName = _a.setVisiblePoJobName, setAlertState = _a.setAlertState;
    var orderNumbers = order.orderNumbers, _h = order.POJobName, POJobName = _h === void 0 ? '' : _h, registerNumber = order.registerNumber, salesDate = order.salesDate, storeNumber = order.storeNumber, transactionId = order.transactionId;
    var _j = useState(''), inputError = _j[0], setInputError = _j[1];
    var _k = useState(false), isLoading = _k[0], setLoading = _k[1];
    var _l = useForm({
        mode: 'onBlur',
        defaultValues: {
            jobName: visiblePoJobName === 'Add PO/Job Name' ? '' : visiblePoJobName,
            tryAgain404: false,
        },
    }), clearErrors = _l.clearErrors, errors = _l.formState.errors, handleSubmit = _l.handleSubmit, register = _l.register, reset = _l.reset, setError = _l.setError, setValue = _l.setValue, watch = _l.watch;
    var watchJobName = watch('jobName');
    useEffect(function () {
        var invalidChars = /[$&+,:;=\\?@(){}~%#\][|/'<>.^*()%!-]/;
        if (invalidChars.test(watchJobName) && watchJobName.length > 0) {
            setInputError('error');
            setError('jobName', { type: 'invalidChar', message: 'invalid entry' });
            return;
        }
        if (watchJobName.length > 0 && watchJobName !== 'Add PO/Job Name') {
            setInputError('success');
            clearErrors('jobName');
            return;
        }
        if (inputError === 'success' && watchJobName.length === 0) {
            setInputError('error');
            setError('jobName', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchJobName]);
    var closeModal = function () {
        setOpenModal(false);
        reset();
        clearErrors();
    };
    var onFormSubmit = function (_a) {
        var jobName = _a.jobName;
        return __awaiter(void 0, void 0, void 0, function () {
            var orderNumber, request, response, tempObj, tempUpdatedOrders, duplIndex, error_1;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        clearErrors();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        orderNumber = (_b = orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) !== null && _b !== void 0 ? _b : '';
                        request = {
                            editPoJobNameRequest: {
                                customerAccountId: getSvocId(),
                                purchaserId: getSvocId(),
                                orderNumber: orderNumber,
                                registerNumber: registerNumber !== null && registerNumber !== void 0 ? registerNumber : 0,
                                salesDate: salesDate !== null && salesDate !== void 0 ? salesDate : '',
                                storeNumber: storeNumber !== null && storeNumber !== void 0 ? storeNumber : 0,
                                transactionId: transactionId !== null && transactionId !== void 0 ? transactionId : 0,
                                newPOJobName: jobName,
                            },
                        };
                        return [4 /*yield*/, editPOJobName(request)];
                    case 2:
                        response = _c.sent();
                        if (response.data.editPOJobNameStatus) {
                            setVisiblePoJobName(jobName);
                            if (setAlertState) {
                                setAlertState({
                                    status: 'success',
                                    alertMessage: 'PO/Job Name Saved',
                                    onClose: function () { return setAlertState(null); },
                                });
                            }
                            reset();
                            tempObj = __assign({}, order);
                            tempObj.POJobName = jobName;
                            tempUpdatedOrders = sessionStorage.getItem("".concat(page, "-poJobUpdate"));
                            if (tempUpdatedOrders) {
                                tempUpdatedOrders = JSON.parse(tempUpdatedOrders);
                                duplIndex = tempUpdatedOrders === null || tempUpdatedOrders === void 0 ? void 0 : tempUpdatedOrders.findIndex(function (item) { var _a, _b; return ((_a = item === null || item === void 0 ? void 0 : item.orderNumbers) === null || _a === void 0 ? void 0 : _a[0]) === ((_b = order === null || order === void 0 ? void 0 : order.orderNumbers) === null || _b === void 0 ? void 0 : _b[0]); });
                                if (duplIndex === -1) {
                                    sessionStorage.setItem("".concat(page, "-poJobUpdate"), JSON.stringify(__spreadArray(__spreadArray([], tempUpdatedOrders, true), [
                                        tempObj,
                                    ], false)));
                                }
                                if (duplIndex > -1) {
                                    tempUpdatedOrders[duplIndex] = tempObj;
                                    sessionStorage.setItem("".concat(page, "-poJobUpdate"), JSON.stringify(__spreadArray([], tempUpdatedOrders, true)));
                                }
                            }
                            else {
                                sessionStorage.setItem("".concat(page, "-poJobUpdate"), JSON.stringify([tempObj]));
                            }
                            setOpenModal(false);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        setEditJobNameError(error_1);
                        setLoading(false);
                        setError('tryAgain404', {
                            type: 'failed',
                            message: 'failed request',
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return (React.createElement("div", { "data-testid": "editPOJobNameModal" },
        React.createElement(Modal, { open: openModal, onClose: closeModal, size: "sm" },
            React.createElement(ModalHeader, { onClose: closeModal }, POJobName === (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || POJobName === ''
                ? 'Add PO/Job Name'
                : 'Edit PO/Job Name'),
            React.createElement(ModalBody, null,
                React.createElement(FormController, { className: "sui-mt-6", fullWidth: true, status: inputError || ((errors === null || errors === void 0 ? void 0 : errors.jobName) && 'error') },
                    React.createElement(FormLabel, { htmlFor: "jobName" },
                        "PO/Job Name",
                        React.createElement("sup", null, "*")),
                    React.createElement(Input, __assign({ "aria-describedby": "jobName-input", fullWidth: true, id: "jobName" }, register('jobName', {
                        required: true,
                        minLength: 1,
                        onChange: function (event) {
                            return setValue('jobName', event.target.value);
                        },
                        onBlur: function (event) {
                            return setValue('jobName', event.target.value);
                        },
                    }), { placeholder: "Enter PO/Job Name" })),
                    (inputError === 'error' ||
                        errors.jobName ||
                        errors.tryAgain404) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                        ((_b = errors === null || errors === void 0 ? void 0 : errors.jobName) === null || _b === void 0 ? void 0 : _b.type) === 'invalidChar' &&
                            'Only letters and numbers are allowed.',
                        (['min', 'failed', 'required'].includes((_d = (_c = errors === null || errors === void 0 ? void 0 : errors.jobName) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : '') ||
                            watchJobName.length === 0) &&
                            'Please enter a PO/Job Name',
                        errors.tryAgain404 &&
                            'Something went wrong. Please refresh the page and try again.')))),
            React.createElement(ModalFooter, { position: "end" },
                React.createElement("div", { className: "ButtonGroup sui-min-w-full sui-flex sui-gap-4 sui-flex-col-reverse md:sui-flex-row lg:sui-flex-row" },
                    React.createElement(Button, { disabled: POJobName === (orderNumbers === null || orderNumbers === void 0 ? void 0 : orderNumbers[0]) || POJobName === '', variant: "secondary", fullWidth: true, onClick: handleSubmit(function () {
                            return onFormSubmit({ jobName: '' });
                        }) }, "Delete"),
                    React.createElement(LoadingButton, { fullWidth: true, loading: isLoading, onClick: handleSubmit(onFormSubmit), variant: "primary", disabled: ['error', ''].includes(inputError) ||
                            ((_e = errors.jobName) !== null && _e !== void 0 ? _e : false) ||
                            ((_f = errors.tryAgain404) !== null && _f !== void 0 ? _f : false) }, "Submit"))))));
};
